import { useEffect } from "react";

// Desktop tab identity: monitor icon + "Desktop" title while /desktop is open; restores on leave.
export function useDesktopBrand() {
  useEffect(() => {
    const prevTitle = document.title;
    const links = Array.from(document.querySelectorAll("link[rel='icon']"));
    const prev = links.map((el) => ({ el, href: el.getAttribute("href"), type: el.getAttribute("type") }));
    document.title = "Desktop — Catskills Pool Supplies";
    links.forEach((el) => { el.setAttribute("href", "/desk-icon-192.png"); el.setAttribute("type", "image/png"); });
    return () => {
      document.title = prevTitle;
      prev.forEach(({ el, href, type }) => {
        if (href) el.setAttribute("href", href); else el.removeAttribute("href");
        if (type) el.setAttribute("type", type); else el.removeAttribute("type");
      });
    };
  }, []);
}
